import React from 'react'
import Head from 'next/head'

const MetaLayout = ({ title, description, children }) => {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={title} key="ogtitle" />
        <meta property="og:description" content={description} key="ogdesc" />
        <meta name="description" content={description}></meta>
        {process.env.NEXT_PUBLIC_TOGGLE && (
          <meta name="robots" content="noindex" />
        )}
      </Head>
      {children}
    </>
  )
}

export default MetaLayout
